<svelte:options runes={false} />

<script>
  import Pagination from './Pagination.svelte';

  export let invoices;
  export let activeInvoiceId;
  export let page;
  export let hasNext;
  export let onSelect;
  export let onPrevious;
  export let onNext;
</script>

<div class="invoice-list">
  {#each invoices as candidate (candidate._id)}
    <button class:primary={candidate._id === activeInvoiceId} type="button" on:click={() => onSelect(candidate._id)}>
      <span class="invoice-row-recipient">{candidate.recipientLabel}</span>
    </button>
  {/each}
</div>
<Pagination {page} {hasNext} {onPrevious} {onNext} />
